import { useAuth } from '@modules/auth/hooks';
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { STUDY_INSIGHTS_SEQUENCED_SAMPLES } from '../constants/api';
import { fetchSamplesSequenced } from '../services';
import { SequencedSamples } from '../types/sequenced-samples.types';
import { SampleStatus, FetchSamplesParam } from '@modules/study-insights/types/samples.types';

const useQuerySequencedSamples = <TError = unknown>(
  params: FetchSamplesParam,
  options?: Omit<
    UseQueryOptions<
      SequencedSamples | undefined,
      TError,
      SequencedSamples,
      Array<string | SampleStatus[] | (Date | string | undefined)>
    >,
    'initialData' | 'queryFn' | 'queryKey'
  >,
): UseQueryResult<SequencedSamples> => {
  const { isAuthenticated } = useAuth();
  const enabledOption = options?.enabled !== undefined ? !!options?.enabled : true;
  return useQuery(
    [STUDY_INSIGHTS_SEQUENCED_SAMPLES, params.sampleStatus, params.startDate, params.endDate],
    async () => await fetchSamplesSequenced(params),
    {
      ...options,
      enabled: isAuthenticated === true && enabledOption,
    },
  );
};

export default useQuerySequencedSamples;
